import "./App.css";
import { Bg, MultiFaceSelect } from "@/components";
import { DragEventHandler, useEffect, useRef } from "react";
import { useCommonStore, useUserStore } from "./stores";
import {
  autoShowOpenAppConfirm,
  getSafariInfo,
  loadAdsJs,
  myBrowserOS,
  setCookie,
} from "./utils";
import { ToastContainer, Bounce } from "react-toastify";
import { useIsMobile } from "@/hooks";
import { HEADER_RESIDENT_ID } from "./constants";
import { useTranslation } from "react-i18next";
// import FTAnalytic from "@/analyze/FTAnalytic";
import clsx from "clsx";
import Header from "./components/header";
// import PCMain from "./components/PCComponent/PCMain";
// import MobileMain from "./components/MobileMain/MobileMain";
import { FeatureType } from "./stores/useCommonStore";
import Analyse from "./utils/analyse";
import loadable from "@loadable/component";
import MobileMainSkeleton from "./components/MobileMain/MobileMainSkeleton";
import PCMainSkeleton from "./components/PCComponent/PCMain_skelton";
const PCMain = loadable(
  () =>
    import(
      /* webpackChunkName: "p_main" */
      "./components/PCComponent/PCMain"
    ),
  {
    fallback: <PCMainSkeleton />,
  }
);
const MobileMain = loadable(
  () =>
    import(
      /* webpackChunkName: "m_main" */
      "./components/MobileMain/MobileMain"
    ),
  {
    fallback: <MobileMainSkeleton />,
  }
);

const App = () => {
  const { i18n } = useTranslation();

  const headerCompRef = useRef<any>();

  const isMobile = useIsMobile();
  console.log("isMobile", isMobile);
  const adLoaded = useCommonStore((state) => state.adLoaded);
  const multiFaceSelectOptions = useCommonStore(
    (state) => state.multiFaceSelectOptions
  );
  const userInfo = useUserStore((state) => state.userInfo);
  const generating = useCommonStore((state) => state.generating);
  const credits = useUserStore((state) => state.credits);
  const setAdLoaded = useCommonStore((state) => state.setAdLoaded);
  const setIsMobile = useCommonStore((state) => state.setIsMobile);
  const fetchCredits = useUserStore((state) => state.fetchCredits);
  const preApplyPresetTemp = useCommonStore(
    (state) => state.preApplyPresetTemp
  );
  const applyPresetTemp = useCommonStore((state) => state.applyPresetTemp);
  const setSafariInfo = useCommonStore((state) => state.setSafariInfo);
  const showPayment = useUserStore((state) => state.showPayment);
  const receiveCredits = useUserStore((state) => state.receiveCredits);
  const setIsDrag = useCommonStore((state) => state.setIsDrag);
  const showLogin = useUserStore((state) => state.showLogin);

  const userInfoRef = useRef<any>(userInfo); // 用户信息引用地址

  const handleDragEnter: DragEventHandler<HTMLDivElement> = (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (!generating) {
      setIsDrag(true);
    }
  };

  const handleShowPayment = (promotionId: string) => {
    showPayment({
      options: {
        position: "swap_generate",
      },
      otherParam: {
        scenesId: "032",
        promotionId: promotionId || "",
      },
      callback: () => {
        fetchCredits();
      },
    });
  };

  useEffect(() => {
    (async () => {
      preApplyPresetTemp();
      await useCommonStore.getState().fetchPresetGroupListByFeatureType();
      applyPresetTemp();
      Analyse.getInstance().enterPage();
    })();
  }, []);

  useEffect(() => {
    setIsMobile(isMobile);
  }, [isMobile]);

  useEffect(() => {
    // 准备用户环境
    useUserStore.getState().readyEnvironment();
  }, []);

  // 埋点（进入工具）

  useEffect(() => {
    setSafariInfo(getSafariInfo());
  }, []);

  useEffect(() => {
    const listener = () => {
      // languageChanged 事件在语言改变前就执行了，这里给个延迟，让其在改变后执行
      setTimeout(() => {
        useCommonStore.getState().fetchPresetGroupListByFeatureType(true);
      }, 500);
    };

    i18n.on("languageChanged", listener);

    return () => {
      i18n.off("languageChanged", listener);
    };
  }, []);

  // 加载广告
  useEffect(() => {
    if (navigator.userAgent !== "ReactSnap") {
      const { iPad } = myBrowserOS();
      if (!isMobile && !iPad) {
        loadAdsJs().then(() => {
          window.adpopup?.fillAds(
            [
              { eleId: "banner_ad", type: "top" },
              {
                eleId: HEADER_RESIDENT_ID,
                type: "resident",
              },
            ],
            (el: any) => {
              if (el.type === "close" && el.adData.type === "top") {
                setAdLoaded(false);
              }

              if (
                el.haveAd &&
                el.adDomId === "banner_ad" &&
                el.type === "loaded"
              ) {
                setAdLoaded(true);
              }

              if (el.type === "confirm" && el.action === false) {
                if (
                  el.adData.jumpUrl === "upgrade" ||
                  el.adData.jumpUrl === "upgradesvip"
                ) {
                  const userInfo = userInfoRef.current;
                  const promotionId =
                    el.adData.promotionId &&
                    el.adData.promotionId !== null &&
                    el.adData.promotionId.length > 0
                      ? el.adData.promotionId[0]
                      : "";

                  if (userInfo) {
                    handleShowPayment(promotionId);
                  } else {
                    showLogin({
                      options: {
                        position: `face_swapper_login_ad_activity_${promotionId}`,
                      },
                      callback: () => {
                        handleShowPayment(promotionId);
                      },
                      errCallback: () => {},
                    });
                  }
                } else {
                  window.open(el.adData.jumpUrl, "__blanck");
                }
              } else if (el.type === "confirm") {
                window.open(el.adData.jumpUrl);
              }
            }
          );
        });
      }
    }
  }, [userInfo, isMobile]);

  useEffect(() => {
    userInfoRef.current = userInfo;
  }, [userInfo?.fotorToken]);

  useEffect(() => {
    const visibilitychange = async () => {
      if (document.visibilityState === "visible") {
        await receiveCredits();
        await fetchCredits();
      }
    };
    document.addEventListener("visibilitychange", visibilitychange);

    return () => {
      document.removeEventListener("visibilitychange", visibilitychange);
    };
  }, []);

  useEffect(() => {
    headerCompRef.current?.updateCredits(credits);
  }, [credits]);

  // useEffect(() => {
  //   autoShowOpenAppConfirm();
  // }, []);

  return (
    <div className="app" id="app" onDragEnter={handleDragEnter}>
      {!isMobile && <Bg></Bg>}

      <div id="banner_ad" className={clsx(adLoaded && "top_ad")}></div>

      <Header />
      {!isMobile && <PCMain></PCMain>}
      {/* <PCMain/> */}
      {isMobile && <MobileMain></MobileMain>}

      {/* {isMobile === false && <Main></Main>} */}

      {/* {!isMobile&& shareOption.show && <Share></Share>} */}

      {multiFaceSelectOptions.show && <MultiFaceSelect></MultiFaceSelect>}

      {/* {!isMobile && isDrag && <FullScreenDragUpload></FullScreenDragUpload>} */}

      <ToastContainer
        position="top-center"
        autoClose={1500}
        hideProgressBar
        newestOnTop={false}
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="colored"
        transition={Bounce}
        closeButton={false}
        limit={3}
        className="custom_toast_container"
        toastClassName="custom_toast"
        bodyClassName="custom_toast_body"
      />
    </div>
  );
};

export default App;
